<template>
    <!-- vue.js will merge class and style attribute -->
    <np-responsive>
        <template #label>
            <span>{{label}}</span></template>
        <template #input>
        <div class="form-group">
            <select ref="select" :name="name" required="required" class="form-control">
                <option value="">{{lang('select_country')}}</option>
                <option v-for="country in countries" :value="country.iso3">{{country.printable_name}}</option>
            </select>
        </div>
        </template>
    </np-responsive>
</template>
<script>
    import NPSelect2 from './np-select2.vue';
    import NpResponsive from "./np-responsive.vue";

    export default {
        name: 'np-country-select',
        components: {NpResponsive},
        mixins: [NPSelect2],
        props: {
            label: String,
            countries: Array
        },
        methods: {
            formatSelection: function(state) {
                const country_iso = state.id;
                if (country_iso && country_iso.length > 0) {
                    var img = ' <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> ';
                    return img + state.text;
                } else {
                    return state.text;
                }
            },
        },
    }
</script>